var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcellent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.36,
    height: 88.361,
    viewBox: "0 0 88.36 88.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1325",
    "data-name": "Group 1325",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_233",
    "data-name": "Ellipse 233",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(23.285 39.404) rotate(-80.78)",
    fill: "#5bba54"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_234",
    "data-name": "Ellipse 234",
    cx: 5.771,
    cy: 5.771,
    r: 5.771,
    transform: "translate(51.755 34.626) rotate(-45)",
    fill: "#5bba54"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1324",
    "data-name": "Group 1324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4129",
    "data-name": "Path 4129",
    d: "M557.6,533.19a44.18,44.18,0,1,0,44.18,44.18A44.229,44.229,0,0,0,557.6,533.19Zm39.225,44.18A39.225,39.225,0,1,1,557.6,538.145,39.27,39.27,0,0,1,596.824,577.37Z",
    transform: "translate(-513.42 -533.19)",
    fill: "#59b952"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4130",
    "data-name": "Path 4130",
    d: "M654.561,870.568a23.461,23.461,0,0,0,46.922,0V868.09H654.56v2.478Zm41.8,2.478a18.51,18.51,0,0,1-36.683,0h36.684Z",
    transform: "translate(-633.845 -818.936)",
    fill: "#59b952"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellent);
export default __webpack_public_path__ + "static/media/Excellent.4a9122e57b7ee66fe6c4fb7c7453de4e.svg";
export { ForwardRef as ReactComponent };